import React, { useEffect } from 'react'
import { FaLinkedin } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import 'aos/dist/aos.css';
import AOS from 'aos';
const ContactUs = () => {
    useEffect(() => {
        AOS.init({
            // Global settings here...
        });
    }, []);
    return (
        <div id='contact' className='py-32 lg:py-36 xl:py-40 px-5 md:px-8 flex flex-col justify-center items-center bg-[#111111]'>
            <div

                className='w-full max-w-[1100px]'>
                <hr className='mb-16 border-0 h-[1px] bg-[#2a2a2a]' />
                <h1 className='text-primary-dark metro-semi mb-6 text-[34px]' data-aos="fade-up" data-aos-duration="1000">Contact & Institutional Information</h1>
                <h1 data-aos="fade-up" data-aos-duration="1000" className='text-white section-headline domin mb-10 lg:mb-12'>Contact Qlab for investor relations, research collaboration, and technology partnerships.</h1>
                <p className='text-[18px] mb-4 md:text-[20px] lg:text-[26px] xl:text-[30px] text-secondary-light'>Investor Relations</p>
                <p className='text-[18px] mb-4 md:text-[20px] lg:text-[26px] xl:text-[30px] text-secondary-light'>Research Collaboration</p>
                <p className='text-[18px] mb-12 md:text-[20px] lg:text-[26px] xl:text-[30px] text-secondary-light'>Technology Partnerships</p>
                <hr className='w-[4rem] mt-20 block h-[1px] bg-primary-dark border-primary-dark items-center my-4 b ' />
                <a
                    href='mailto:contact@qlab.work'
                    className='pb-3 border-b border-transparent text-[30px] md:text-[36px] text-white metro transition-all duration-300 hover:border-secondary-light whitespace-normal'
                    style={{ wordWrap: 'break-word' }}
                >
                    contact@qlab.work
                </a>

                <p className='text-[18px] mb-20 md:text-[20px] lg:text-[26px] xl:text-[30px] text-secondary-light'>Beloura Office Park - EE13 Quinta da Beloura EE13, Sintra, Portugal</p>


                <div className='grid grid-cols-1 lg:grid-cols-2 items-center'>
                    <div>
                        <h1 className='text-[14px] md:text-[15px] mb-3 lg:text-[16px] metro-semi text-primary-dark upercase' >/ Follow Us</h1>
                        <a target="_blank" rel="noopener noreferrer" href='https://www.linkedin.com/company/qlabs-work/?viewAsMember=true'> <FaLinkedin className='block  text-secondary-light text-4xl mb-3' /></a>

                        <Link to={'/terms-and-conditions'}> <p className='block  text-secondary-light text-xl ' >Terms</p></Link>
                    </div>


                </div>
                <p className='block  text-secondary-light text-xl text-center mt-10'>The information on this website is for informational purposes only and does not constitute investment advice or an offer to invest.</p>
                <p className='block  text-secondary-light text-xl text-center mt-4'>Due to the proprietary nature of our research, specific models, datasets, and strategies are not publicly disclosed.</p>
                <p className='block  text-secondary-light text-xl text-center mt-4'>Copyright @2024  All rights reserved by qlab.work</p>
            </div>
        </div>
    )
}

export default ContactUs
